import { useEffect, useMemo, useState } from 'react';

import type { DocNode } from '@atlaskit/adf-schema';

import { useDocumentUpdateStatus } from '@confluence/annotation-provider-store/entry-points/DocumentUpdateStatusContext.ts';

export const useADFDocument = (adf: string, isFabric: boolean): [DocNode] => {
	const { documentUpdated } = useDocumentUpdateStatus();
	const docParsed = useMemo(() => {
		let documentParsed: DocNode = {
			version: 1,
			type: 'doc',
			content: [],
		};

		if (adf && isFabric) {
			try {
				documentParsed = JSON.parse(adf);
			} catch (e) {
				throw Error('Failed to parse ADF');
			}
		}
		return documentParsed;
	}, [adf, isFabric]);

	const [document, setDocument] = useState(docParsed);

	useEffect(() => {
		setDocument(docParsed);
	}, [docParsed, documentUpdated]);
	return [document];
};
